import {
  Spacing
} from 'UI'

export default {
  main: {
  },
  aside: {
  },
  similarCourses: {
    margin: () => Spacing(0, 0, 11, 0)
  },
  tableOfContentAndRequirement: {
    margin: () => Spacing(0, 0, 11, 0)
  },
  tableOfContent: {
    width: '100%'
  },
  requirements: {
    width: '100%'
  },
  reviews: {
    margin: () => Spacing(0, 0, 11, 0)
  },
  pricing: {
    margin: () => Spacing(0, 0, 8, 0)
  }
}
